import React from "react";
import { UserMenu, UserMenuProps } from "react-admin";
import { LogoutButtonJwt } from "./LogoutButtonJwt";

export const UserMenuJwt: React.FC<UserMenuProps> = (props) => (
  <UserMenu {...props}>
    <LogoutButtonJwt />
  </UserMenu>
);
